import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic, faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

const Nav = ({ libraryStatus, setLibraryStatus, themeHandler, darkTheme }) => {
  return (
    <nav>
      <h1>Waves</h1>
      <FontAwesomeIcon
        icon={darkTheme ? faSun : faMoon}
        size="3x"
        color="yellow"
        onClick={themeHandler}
      />
      <button onClick={() => setLibraryStatus(!libraryStatus)}>
        Library
        <FontAwesomeIcon icon={faMusic} />
      </button>
    </nav>
  );
};

export default Nav;
